import React from 'react';
import PropTypes from 'prop-types';
import { MDText } from 'i18n-react';
import { useLocale } from '@adsk/bim360-matrix-react-helpers/es/locale';
import { ENTITY_TYPES } from '@adsk/bim360-matrix-react-entity-linker';
import { statusColorMapping } from './consts';
import EntityPickerItem from '../../EntityPickerItem';

/**
 * A component rendering Issue entity picker item.
 * @param entity
 * @param rest
 * @returns {*}
 * @constructor
 */
const IssueEntityPickerItem = ({ entity, ...rest }) => {
  const { T } = useLocale(({ locale }) => new MDText(require(`./i18n/${locale}.json`)));
  const { id, status, title, displayId } = entity;
  const userFriendlyId = displayId ? `#${displayId}` : displayId;
  const statusColor = status ? statusColorMapping[status] : null;
  const statusTextKey = status ? status.toUpperCase() : null;
  const statusText = statusTextKey ? T.translate(statusTextKey) : null;

  return (
    <EntityPickerItem
      entityType={ENTITY_TYPES.ISSUE}
      id={id}
      title={title}
      userFriendlyId={userFriendlyId}
      statusColor={statusColor}
      statusText={statusText}
      {...rest}
    />
  );
};

IssueEntityPickerItem.propTypes = {
  /**
   * The issue entity we need to render.
   */
  entity: PropTypes.shape({
    id: PropTypes.string.isRequired,
    title: PropTypes.string.isRequired,
    status: PropTypes.string.isRequired,
    displayId: PropTypes.number.isRequired
  }).isRequired
};

export default IssueEntityPickerItem;
